module.exports = __webpack_public_path__ + "img/addImg.dc259c35.png";